var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0909 5.27273C15.6364 4.72727 15.6364 3.90909 15.0909 3.36364L12.6364 0.909091C12.0909 0.363636 11.2727 0.363636 10.7273 0.909091L0.5 11.1364V15.5H4.86364L15.0909 5.27273ZM11.6818 1.86364L14.1364 4.31818L12.0909 6.36364L9.63636 3.90909L11.6818 1.86364ZM1.86364 14.1364V11.6818L8.68182 4.86364L11.1364 7.31818L4.31818 14.1364H1.86364Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.559ddcdd8587e1d7ab6f0034e039f8dc.svg";
export { ForwardRef as ReactComponent };